import { EProductType } from "../models/requests/e-product-type";
import { EJustificationType } from "../models/requests/e-justification-type";

/**
 * Retorna o nome amigável em português para o tipo de produto
 * @param type Tipo de produto
 * @returns Nome do tipo em português
 */
export const getProductTypeName = (type: EProductType): string => {
  switch (type) {
    case EProductType.DryLoad:
      return "Carga seca";
    case EProductType.Bulk:
      return "Granéis";
    case EProductType.Other:
      return "Outros";
    default:
      return "Desconhecido";
  }
};

/**
 * Retorna o nome amigável em português para o tipo de justificativa
 * @param type Tipo de justificativa
 * @returns Nome do tipo em português
 */
export const getJustificationTypeName = (type: EJustificationType): string => {
  switch (type) {
    case EJustificationType.Cancellation:
      return "Cancelamento";
    case EJustificationType.Modification:
      return "Modificação";
    default:
      return "Desconhecido";
  }
}; 